export default async function urlToBase64(url) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    blob.filename = url.split("/").pop();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Base64 convert error", error);
    return null;
  }
}
